(function ($, Drupal, window, document) {
  Drupal.behaviors.myLenis = {
    attach: function (context, settings) {
      // Initialize Lenis
      const lenis = new Lenis({
        autoRaf: true,
      });

      // Listen for the scroll event and log the event data
      lenis.on('scroll', (e) => {
      });

      $(document).on('dialog:beforecreate', function(event, ui) {
        console.info('open');
        const $dialog = $(event.target);
        $dialog.attr('data-lenis-prevent', 'true');
        document.dispatchEvent(new CustomEvent('dialog:open', { detail: $dialog }));
      });

      // Drupal-Modal schließen überwachen
      $(document).on('dialog:close', function(event) {
        console.info('close');
        document.dispatchEvent(new CustomEvent('dialog:close'));
      });
    }
  };

}) (jQuery, Drupal, this, document);
